import { PureComponent } from "react";

import { componentStyles } from "./video-thumbnail-item-component.scss";

import PlayButtonIcon from "/static/svg/videos/video-play-button.svg";

import { getAssetPath } from "/services/assets-service";

export default class VideoThumbnailItemComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    const { index, onClick } = this.props;
    onClick(index);
  }

  render() {
    const { title, thumbnailSrc } = this.props;

    return (
      <div className="video-thumbnail-item-component" onClick={this.onClick}>
        <div className="thumbnail-image-part">
          <div className="thumbnail-image" style={{ backgroundImage: `url(${getAssetPath(thumbnailSrc)})` }} />
          <div className="play-icon-container">
            <PlayButtonIcon />
          </div>
        </div>

        <div className="thumbnail-text-part">
          <div className="video-title" dangerouslySetInnerHTML={{ __html: title }} />

          <div className="link-indicator">Watch video</div>
        </div>

        <style jsx>
          {componentStyles}
        </style>
      </div>
    );
  }
}
